import { analytics } from '@heycatch/sdk';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.tsx';
import './index.css';

analytics.init({
  projectKey: 'hck_pk_PxbXU9cKaEyNjWHTH2zonVgew4eufiCa',
  install: {
    framework: 'vite-react',
    frameworkVersion: '18',
    agent: 'bolt',
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>
);